import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Modal, Form, Button } from "react-bootstrap";
import { P2PsportEndPoint, sportEndPoint } from "../../constant/Environment";
import { getAllSportData } from "../../Utility/API";
import ResultSearch from "../../components/FilterComponent/ResultSearch";
import FilterComponent from "../../components/FilterComponent";
import Loader from "../../components/Loader";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import ListGroup from "react-bootstrap/ListGroup";
import moment from "moment-timezone";

function getNumberOfPages(rowCount, rowsPerPage) {
  return Math.ceil(rowCount / rowsPerPage);
}

function toPages(pages) {
  const results = [];
  for (let i = 1; i <= pages; i++) {
    results.push(i);
  }

  return results;
}

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const columns = [
  {
    name: "Bet Id",
    selector: (row) => row.id,
    sortable: true,
  },
  {
    name: "Sport",
    selector: (row) => row.playerData[0].playerevent.sport.name,
    sortable: true,
  },
  {
    name: "League",
    selector: (row) => row.playerData[0].playerevent.league.name,
    sortable: true,
  },
  {
    name: "Event",
    selector: (row) => row.playerData[0].single_event,
    sortable: true,
  },
  {
    name: "Market",
    selector: (row) => row.playerData[0].statName,
    sortable: true,
  },
  {
    name: "User",
    selector: (row) => row.userId,
    sortable: true,
  },
  {
    name: "Platform",
    selector: (row) => row.platform,
    sortable: true,
  },
  {
    name: "Date",
    selector: (row) => row.createdDate,
    sortable: true,
  },
  {
    name: "Amount",
    selector: (row) => row.wager,
    sortable: true,
  },
  {
    name: "Win Amount",
    selector: (row) => row.amount,
    sortable: true,
  },
  {
    name: "Type",
    selector: (row) => row.type,
    sortable: true,
  },
  {
    name: "Status",
    selector: (row) => row.status.toUpperCase(),
    sortable: true,
  },
  {
    name: "Result",
    selector: (row) => row.defineresult,
    sortable: true,
  },
];

// RDT exposes the following internal pagination properties
// const BootyPagination = ({
//   rowsPerPage,
//   rowCount,
//   onChangePage,
//   onChangeRowsPerPage, // available but not used here
//   currentPage,
// }) => {
//   const handleBackButtonClick = () => {
//     onChangePage(currentPage - 1);
//   };

//   const handleNextButtonClick = () => {
//     onChangePage(currentPage + 1);
//   };

//   const handlePageNumber = (e) => {
//     onChangePage(Number(e.target.value));
//   };

//   const pages = getNumberOfPages(rowCount, rowsPerPage);
//   const pageItems = toPages(pages);
//   const nextDisabled = currentPage === pageItems.length;
//   const previosDisabled = currentPage === 1;

//   return (
//     <nav>
//       <ul className="pagination">
//         <li className="page-item">
//           <button
//             className="page-link"
//             onClick={handleBackButtonClick}
//             disabled={previosDisabled}
//             aria-disabled={previosDisabled}
//             aria-label="previous page"
//           >
//             Previous
//           </button>
//         </li>
//         {pageItems.map((page) => {
//           const className =
//             page === currentPage ? "page-item active" : "page-item";

//           return (
//             <li key={page} className={className}>
//               <button
//                 className="page-link"
//                 onClick={handlePageNumber}
//                 value={page}
//               >
//                 {page}
//               </button>
//             </li>
//           );
//         })}
//         <li className="page-item">
//           <button
//             className="page-link"
//             onClick={handleNextButtonClick}
//             disabled={nextDisabled}
//             aria-disabled={nextDisabled}
//             aria-label="next page"
//           >
//             Next
//           </button>
//         </li>
//       </ul>
//     </nav>
//   );
// };

const Bets = () => {
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [selectedBet, setSelectedBet] = useState({});
  const [isLoading, setIsLoadinig] = useState(false);
  const [filterText] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  // const filteredItems = rows?.filter(
  //   (item) =>
  //     item?.name && item?.name?.toLowerCase()?.includes(filterText?.toLowerCase())
  // );

  useEffect(() => {
    fetchBetData();
  }, []);

  const fetchBetData = async () => {
    let url = `${P2PsportEndPoint.apiBaseUrl + P2PsportEndPoint.api.GET_BETS}`;
    await getAllSportData(url)
      .then((response) => {
        if (response) {
          // debugger;
          setRows(response);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div className="main">
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-2">Multiline Bets</h2>
                </div>
              </div>
              <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                <div className="col-md-12">
                  {/* <ResultSearch searchBetData={fetchBetData} /> */}
                </div>
              </div>
              {/* <div className="container-fluid table-custom">
                <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                  <div className="col-md-12">
                    <DataTable
                      title=""
                      columns={columns}
                      data={rows}
                      defaultSortFieldID={1}
                      pagination
                      paginationComponent={BootyPagination}
                      paginationResetDefaultPage={resetPaginationToggle} 
                    />
                  </div>
                </div>
              </div> */}
              <div className="container-fluid table-custom">
                <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        aria-label="sticky table"
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Bet ID</TableCell>
                            {/* <TableCell align="center">Sport </TableCell>
                            <TableCell align="center">League</TableCell> */}
                            {/* <TableCell align="center">Event</TableCell> */}
                            {/* <TableCell align="center">Market</TableCell> */}
                            {/* <TableCell align="center">State</TableCell> */}
                            <TableCell align="center">User</TableCell>
                            <TableCell align="center">Platform</TableCell>
                            <TableCell align="center">Date</TableCell>
                            <TableCell align="center">Amount </TableCell>
                            <TableCell align="center">Wining Amount</TableCell>
                            <TableCell align="center">Bet Result</TableCell>
                            <TableCell align="center">Bet Status</TableCell>
                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          { rows.length > 0 &&(rowsPerPage > 0
                            ? rows?.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            : rows
                          ).map((row) => (
                            <TableRow
                              key={row.idUser}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">{row?.id}</TableCell>
                              {/* <TableCell align="center">
                                {row?.playerData[0]?.playerevent?.sport?.name}
                              </TableCell>
                              <TableCell align="center">
                                {row?.playerData[0]?.playerevent?.league?.name}
                              </TableCell>
                              <TableCell align="center">
                                {row?.playerData[0]?.single_event}
                              </TableCell>
                              <TableCell align="center">
                                {row?.playerData[0]?.statName}
                              </TableCell> */}
                              <TableCell align="center">{row?.userId}</TableCell>
                              <TableCell align="center">
                                {row?.platform}
                              </TableCell>
                              <TableCell align="center">
                                {moment(row?.createdDate).format("ddd, MMM D, h:mm A")}
                              </TableCell>
                              <TableCell align="center">${row?.wager}</TableCell>
                              <TableCell align="center">${row?.amount}</TableCell>
                              <TableCell align="center" style={{textTransform:"capitalize"}}>{row?.defineresult}</TableCell>
                              <TableCell align="center">{row?.status}</TableCell>
                              <TableCell align="center">
                                <Button
                                  variant="primary"
                                  className="mrglft10"
                                  onClick={() => {
                                    setShow(true);
                                    setSelectedBet(row);
                                  }}
                                >
                                  View
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  {show && (
                    <Modal
                      show={show}
                      onHide={handleClose}
                      size="xl"
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                          Player Details
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                       
                        {/* <div className="col-md-12" style={{ display: 'flex', gap: '20px' }}>
                          <div className="col-md-6">
                            <ListGroup as="ul">
                              <ListGroup.Item as="li" active>
                                Bet Detail
                              </ListGroup.Item>
                         
                              <ListGroup.Item
                                as="li"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>Bet Id : </span>
                                <span> {selectedBet?.id} </span>
                              </ListGroup.Item>
                              <ListGroup.Item
                                as="li"
                                disabled
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>User : </span>
                                <span> {selectedBet?.userId} </span>
                              </ListGroup.Item>
                              <ListGroup.Item
                                as="li"
                                disabled
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>Type : </span>
                                <span> {selectedBet?.type} </span>
                              </ListGroup.Item>
                              <ListGroup.Item
                                as="li"
                                disabled
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>Amount : </span>
                                <span>
                                  {"$"}
                                  {selectedBet?.amount != undefined
                                    ? selectedBet?.amount?.toFixed(2)
                                    : 0.0}{" "}
                                </span>
                              </ListGroup.Item>
                              <ListGroup.Item
                                as="li"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>Potential : </span>
                                <span>
                                  {"$"}
                                  {selectedBet?.projectedAmount != undefined
                                    ? selectedBet?.projectedAmount.toFixed(2)
                                    : 0.0}{" "}
                                </span>
                              </ListGroup.Item>
                              <ListGroup.Item
                                as="li"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>Stake : </span>
                                <span>
                                  {"$"}
                                  {selectedBet?.wager != undefined
                                    ? selectedBet?.wager.toFixed(2)
                                    : 0.0}{" "}
                                </span>
                              </ListGroup.Item>
                            </ListGroup>
                          </div>

                          <div className="col-md-5">
                            <ListGroup as="ul">
                              <ListGroup.Item as="li" active>
                                Actions
                              </ListGroup.Item>
                              <ListGroup.Item
                                as="li"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>Status : </span>
                                <span> {selectedBet?.status} </span>
                              </ListGroup.Item>
                              <ListGroup.Item
                                as="li"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>Result : </span>
                                <span> {selectedBet?.defineresult} </span>
                              </ListGroup.Item>
                              <ListGroup.Item
                                as="li"
                                disabled
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>Cashout : </span>
                                <span> {selectedBet?.status != 'SETTLED' ? 'No' : 'Yes'} </span>
                              </ListGroup.Item>
                              <ListGroup.Item
                                as="li"
                                disabled
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>Created Time : </span>
                                <span>



                                  {moment(selectedBet?.createdDate).format("MM/DD/YYYY")} </span>
                              </ListGroup.Item>



                            </ListGroup>

                          </div>
                        </div> */}

                        <div className="col-md-12">
                          <TableContainer component={Paper}>
                            <Table
                              size="small"
                              aria-label="a dense table"
                              stickyHeader
                              aria-label="sticky table"
                              sx={{ minWidth: 500 }}
                              aria-label="custom pagination table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center">
                                    Market ID
                                  </TableCell>
                                  <TableCell align="center">Match </TableCell>
                                  <TableCell align="center">
                                    Player Name
                                  </TableCell>
                                  <TableCell align="center">
                                    League Name
                                  </TableCell>
                                  <TableCell align="center">
                                    Stat Name
                                  </TableCell>

                                  <TableCell align="center">More</TableCell>
                                  <TableCell align="center">Less</TableCell>
                                  <TableCell align="center">Points</TableCell>
                                  <TableCell align="center">Multiplier</TableCell>
                                  <TableCell align="center">
                                    Final Score
                                  </TableCell>
                                  <TableCell align="center">Result </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedBet.playerData.map((odd) => (
                                  <TableRow
                                    key={odd.idUser}
                                    sx={{
                                      "&:last-child td, &:last-child th": {
                                        border: 0,
                                      },
                                    }}
                                  >
                                    <TableCell align="center">
                                      {odd.marketId}
                                    </TableCell>
                                    <TableCell align="center">
                                      {odd?.eventName}
                                    </TableCell>
                                    <TableCell align="center">
                                      {odd.name}
                                    </TableCell>
                                    <TableCell align="center">
                                      {odd.leagueName}
                                    </TableCell>
                                    <TableCell align="center">
                                      {odd.marketAbv}
                                    </TableCell>

                                    <TableCell align="center">

                                      {`${odd.isMore}`}
                                    </TableCell>
                                    <TableCell align="center">
                                      {" "}
                                      {`${odd.isLess}`}
                                    </TableCell>
                                    <TableCell>{odd.points}</TableCell>
                                    <TableCell>{odd.multiplier}</TableCell>
                                    <TableCell align="center">
                                      {odd.finalpoints}
                                    </TableCell>
                                    <TableCell align="center">
                                      {odd.defineresult}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                          Close
                        </Button>
                        {/* <Button variant="primary" onClick={handleClose}>
                          Save Changes
                        </Button> */}
                      </Modal.Footer>
                    </Modal>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Bets;
